skrilla.directive('skrPurchaseDetails', function () {
    return {
        templateUrl: 'directives/skrPurchaseDetails/skrPurchaseDetails.html',
        scope: {
            purchase: "="
        },
        controller: function ($scope) {

        }
    };
});
